import { useState } from 'react';
import AudioRecorder from '../AudioRecorder/AudioRecorder';
import css from './ModalForListOfRecordings.module.css';
import { FaArrowLeft } from 'react-icons/fa';
import { BsFillTrashFill } from 'react-icons/bs';

export default function ModalForListOfRecordings({
  audios,
  onClose,
  audioLocalURLs,
  setAudioLocalURLs,
}) {
  const [currentlyPlayingId, setCurrentlyPlayingId] = useState(null);

  const handleRemoveItemFromTheList = id => {
    setAudioLocalURLs(audioLocalURLs?.filter(audio => audio !== id));
  };

  return (
    <div className={css.wrapper}>
      <ul className={css.list}>
        {audios?.map((audio, index) => (
          <li key={index} className={css.listItem}>
            <AudioRecorder
              completedDoc={true}
              audioURL={audio}
              modal={true}
              id={index}
              currentlyPlayingId={currentlyPlayingId}
              setCurrentlyPlayingId={setCurrentlyPlayingId}
            />

            {audioLocalURLs && index < audioLocalURLs?.length && (
              <BsFillTrashFill
                className={css.trashIcon}
                onClick={() => handleRemoveItemFromTheList(audio)}
              />
            )}
          </li>
        ))}
      </ul>

      <div className={css.btnBox}>
        <button className={css.cancelBtn} onClick={onClose}>
          <FaArrowLeft size={40} className={css.cross} />
        </button>
      </div>
    </div>
  );
}
